var _defs, _rect, _polygon, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LH-Z-003783_01_Image",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.51 36.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#414042;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.3,
    y: 8.51,
    width: 9.74,
    height: 19.49
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.3 8.51 15.3 28 25.04 18.25 15.3 8.51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.25,36.51C8.19,36.51,0,28.32,0,18.25S8.19,0,18.25,0s18.25,8.19,18.25,18.25-8.19,18.25-18.25,18.25ZM18.25,1.82C8.52,1.82.61,8.52.61,18.25s7.92,16.43,17.65,16.43,17.64-6.7,17.64-16.43S27.98,1.82,18.25,1.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.84775d7c071cab8d80d16e70625ed2d6.svg";
export { ForwardRef as ReactComponent };